import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
// Constants
import { PROFILE } from '../../Actions/Profile/types';
import {
  getProfileDetailsSuccess,
  getProfileDetailsFailure,
  updateProfileDetailsSuccess,
  updateProfileDetailsFailure,
  getLanguageDetailsSuccess,
  getLanguageDetailsFailure,
  getJobDetailsSuccess,
  getJobDetailsFailure,
  getDepartmentsDetailsSuccess,
  getDepartmentsDetailsFailure,
} from '../../Actions/Profile/profileActions';
import {
  getProfileDetailsApi,
  updateProfileDetailsApi,
  getLanguageDetailsApi,
  getJobDetailsApi,
  getDepartmentDetailsApi,
} from '../../Services/Profile/profileApi';
import i18n from 'src/i18n';
import { stopInitLoadingAction } from 'src/Actions/Generic/genericActions';
import { getSubscription } from 'src/Actions/Subscription/subscriptionAction';

// Saga handlers
export default function* profileSaga() {
  yield takeEvery(PROFILE.GET_PROFILE_DETAILS, fetchprofileDetails);
  yield takeEvery(PROFILE.UPDATE_PROFILE_DETAILS, handleUpdateDetails);
  yield takeEvery(PROFILE.GET_LANGUAGE_DETAILS, fetchlanguageDetails);
  yield takeLatest(PROFILE.GET_JOB_DETAILS, fetchJobDetails);
  yield takeLatest(PROFILE.GET_DEPARTMENT_DETAILS, fetchDepartmentDetails);
}

export function* fetchprofileDetails() {
  try {
    let response = yield call(getProfileDetailsApi);
    if (response && response.status === 200 && response.data) {
      const { language } = response.data;
      switch (language) {
        case "English":
          i18n.changeLanguage('en');
          localStorage.setItem('authLang', 'en');
          break;
        case "French":
          i18n.changeLanguage('fr');
          localStorage.setItem('authLang', 'fr');

          break;
        case "German":
          i18n.changeLanguage('de');
          localStorage.setItem('authLang', 'de');
          break;
        case "Spanish":
          i18n.changeLanguage('es');
          localStorage.setItem('authLang', 'es');
          break;
        case "Italian":
          i18n.changeLanguage('it');
          localStorage.setItem('authLang', 'it');
          break;
        case "Portuguese (Brazil)":
          i18n.changeLanguage('pt');
          localStorage.setItem('authLang', 'pt');
          break;
        case "Indonesian":
          i18n.changeLanguage('id');
          localStorage.setItem('authLang', 'id');
          break;
        case "Japanese":
          i18n.changeLanguage('ja');
          localStorage.setItem('authLang', 'ja');
          break;
        default:
          i18n.changeLanguage('en');
          break;
      }
      yield put(getProfileDetailsSuccess(response.data));
      yield put(stopInitLoadingAction());
    }
  } catch (e) {
    yield put(getProfileDetailsFailure(e));
  }
}

export function* handleUpdateDetails(data) {
  let { request } = data;
  let req = {
    firstName: request.firstName,
    jobTitle: request.jobTitle,
    lastName: request.lastName,
    workPhoneNumber: request.workPhoneNumber
      ? request.workPhoneNumber
      : request.phoneNumber,
    accBodyId: request.accreditingBodyId,
    department: request.department,
    accBodyType: request.accreditingBodyType,
    tncCheck: request.tncCheck ? request.tncCheck : false,
    ucmId: request.ucmId ? request.ucmId : null,
    userId: request.sfdcUserId,
    language: request.language,
  };
  try {
    let response = yield call(updateProfileDetailsApi, req);

    if (response && response.status === 200) {
      let profileDetails = yield call(getProfileDetailsApi);
      if (profileDetails && profileDetails.status === 200 && profileDetails.data) {
        const { language } = profileDetails.data;
        switch (language) {
          case "English":
            i18n.changeLanguage('en');
            localStorage.setItem('authLang', 'en');
            break;
          case "French":
            i18n.changeLanguage('fr');
            localStorage.setItem('authLang', 'fr');

            break;
          case "German":
            i18n.changeLanguage('de');
            localStorage.setItem('authLang', 'de');
            break;
          case "Spanish":
            i18n.changeLanguage('es');
            localStorage.setItem('authLang', 'es');
            break;
          case "Italian":
            i18n.changeLanguage('it');
            localStorage.setItem('authLang', 'it');
            break;
          case "Portuguese (Brazil)":
            i18n.changeLanguage('pt');
            localStorage.setItem('authLang', 'pt');
            break;
          case "Indonesian":
            i18n.changeLanguage('id');
            localStorage.setItem('authLang', 'id');
            break;
          case "Japanese":
            i18n.changeLanguage('ja');
            localStorage.setItem('authLang', 'ja');
            break;
          default:
            break;
        }
        yield put(getSubscription());
        yield put(getProfileDetailsSuccess(profileDetails.data));
        yield put(stopInitLoadingAction());
      }
      yield put(updateProfileDetailsSuccess(response.data));
    }
  } catch (e) {
    yield put(updateProfileDetailsFailure(e));
  }
}

export function* fetchlanguageDetails() {
  try {
    let response = yield call(getLanguageDetailsApi);
    if (response && response.status === 200 && response.data) {
      yield put(getLanguageDetailsSuccess(response.data));
    }
  } catch (e) {
    yield put(getLanguageDetailsFailure(e));
  }
}
export function* fetchJobDetails(data) {
  try {
    let response = yield call(getJobDetailsApi, data.language);
    if (response && response.status === 200 && response.data) {
      yield put(getJobDetailsSuccess(response.data));
    }
  } catch (e) {
    yield put(getJobDetailsFailure(e));
  }
}
export function* fetchDepartmentDetails(data) {
  try {
    let response = yield call(getDepartmentDetailsApi, data.language);
    if (response && response.status === 200 && response.data) {
      yield put(getDepartmentsDetailsSuccess(response.data));
    }
  } catch (e) {
    yield put(getDepartmentsDetailsFailure(e));
  }
}
